import { CommunityFilter } from '../model/CommunityFilter';
import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';

export const MIN_COMMUNITY_LOOKUP_DISTANCE_IN_MILES = 5;

const GET_COMMUNITY_FILTER_QUERY = gql`
  query communityFilter($useDefaultFilter: Boolean) {
    communityFilter(useDefaultFilter: $useDefaultFilter) {
      locationData {
        city
        zipCode
        state
        country
        longitude
        latitude
      }
      distanceInMiles
      ageRangeStartInMonths
      ageRangeEndInMonths
    }
  }
`;

const SAVE_COMMUNITY_FILTER_MUTATION = gql`
  mutation saveCommunityFilter($filter: CommunityFilterPreferenceInput) {
    saveCommunityFilter(filter: $filter)
  }
`;

export const getFilter = async (
  useDefaultFilter = false,
): Promise<CommunityFilter> => {
  const response = await graphql.query<{ communityFilter: CommunityFilter }>({
    query: GET_COMMUNITY_FILTER_QUERY,
    variables: {
      useDefaultFilter: useDefaultFilter,
    },
    fetchPolicy: 'no-cache',
  });
  return response.data.communityFilter;
};

export const saveFilter = async (filter: CommunityFilter) => {
  await graphql.mutate({
    mutation: SAVE_COMMUNITY_FILTER_MUTATION,
    variables: {
      filter: {
        locationData: {
          city: filter?.locationData?.city,
          zip_code: filter?.locationData?.zipCode,
          state: filter?.locationData?.state,
          country: filter?.locationData?.country,
          longitude: filter?.locationData?.longitude,
          latitude: filter?.locationData?.latitude,
        },
        distanceInMiles:
          (filter?.distanceInMiles ?? 0) > 0
            ? filter?.distanceInMiles
            : MIN_COMMUNITY_LOOKUP_DISTANCE_IN_MILES,
        ageRangeStartInMonths: filter?.ageRangeStartInMonths,
        ageRangeEndInMonths: filter?.ageRangeEndInMonths,
      },
    },
  });
};
